/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefSupportReport } from '../../models/api-def-support-report';
import { ApiDefSupportReportCreateRequest } from '../../models/api-def-support-report-create-request';

export interface OrganizationsCreateSupportReport$Params {

/**
 * The ID of the organization
 */
  organizationId: string;
      body: ApiDefSupportReportCreateRequest
}

export function organizationsCreateSupportReport(http: HttpClient, rootUrl: string, params: OrganizationsCreateSupportReport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefSupportReport>> {
  const rb = new RequestBuilder(rootUrl, organizationsCreateSupportReport.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefSupportReport>;
    })
  );
}

organizationsCreateSupportReport.PATH = '/organizations/{organizationId}/support';
